"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var TronContractCallExecutionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(TronContractCallExecutionRequest, _super);
    function TronContractCallExecutionRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputs = [];
        return _this;
    }
    return TronContractCallExecutionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.TronContractCallExecutionRequest = TronContractCallExecutionRequest;
//# sourceMappingURL=TronContractCallExecutionRequest.js.map